<template>
  <div :class="{ flex: activeTab === 'enter' && chooseEnter === 'email' }" class="cabinet-main-btn">
    <button type="submit" class="def-button">
      {{ btnValues }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EnterCabinetMainBtn',
  props: ['btnValues'],
  computed: {
    ...mapState({
      authData: (state) => state.personal.data,
      chooseEnter: ({ personal }) => personal.data.chooseEnter,
      activeTab: ({ personal }) => personal.data.activeTab,
    }),
  },
};
</script>

<style lang="scss" scoped>
.cabinet-main-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .def-button {
    width: 100%;
    border: unset;
  }
}
</style>
